export enum IndexedDbName {
    ORG_ADMIN = 'OrgAdmin',
    ORG_GROUP_ADMIN = 'OrgGroupAdmin'
}